import * as angular from "angular";
import { playService } from "../services/app";
import { ngLeague } from "ng-league/module";
import { LadderRankingController } from "./LadderRanking";
import { SwissRankingController } from "./SwissRanking";
import { component } from "../Component";

export let playRanking = angular.module("play.ranking", [playService.name, ngLeague.name]);

playRanking.component(
    "ladderRanking",
    component({
        bindings: { leagueId: "<" },
        templateCacheUrl: "ranking/ladder.html",
        controllerAs: "ctrl",
        controller: LadderRankingController,
    })
);

playRanking.component(
    "swissRanking",
    component({
        bindings: { leagueId: "<" },
        templateCacheUrl: "ranking/swiss.html",
        controllerAs: "ctrl",
        controller: SwissRankingController,
    })
);
